// Ask-HVAC becomes a multi-page site with the redesign (ASKHVAC-REDESIGN.md).
//
// Every route in the nav spine now has a real page. Cost Guides and
// Financing were the last two placeholders; the open-items review settled
// how both may talk about money (broad educational estimates only, and no
// financing terms at all), which is what unblocked them. The three legal
// documents share one view — see views/LegalView.vue.
//
// InProgressView survives as the catch-all for unknown paths only.
import { createRouter, createWebHistory } from 'vue-router'

import HomeView from './views/HomeView.vue'
import AskView from './views/AskView.vue'
import SecondOpinionView from './views/SecondOpinionView.vue'
import RepairOrReplaceView from './views/RepairOrReplaceView.vue'
import SystemTypesView from './views/SystemTypesView.vue'
import IaqView from './views/IaqView.vue'
import CostGuidesView from './views/CostGuidesView.vue'
import FinancingView from './views/FinancingView.vue'
import AboutView from './views/AboutView.vue'
import LegalView from './views/LegalView.vue'
import InProgressView from './views/InProgressView.vue'

export const router = createRouter({
    history: createWebHistory(),
    scrollBehavior(to, _from, saved) {
        if (saved) return saved
        if (to.hash) return { el: to.hash, behavior: 'smooth' }
        return { top: 0 }
    },
    routes: [
        { path: '/', name: 'home', component: HomeView, meta: { nav: 'home' } },
        { path: '/ask', name: 'ask', component: AskView, meta: { nav: 'ask' } },
        {
            path: '/second-opinion',
            name: 'second-opinion',
            component: SecondOpinionView,
            meta: { nav: 'second-opinion' },
        },
        {
            path: '/repair-or-replace',
            name: 'repair-or-replace',
            component: RepairOrReplaceView,
            meta: { nav: 'repair-replace' },
        },
        {
            path: '/cost-guides',
            name: 'cost-guides',
            component: CostGuidesView,
            meta: { nav: 'costs' },
        },
        {
            path: '/system-types',
            name: 'system-types',
            component: SystemTypesView,
            meta: { nav: 'systems' },
        },
        {
            path: '/indoor-air-quality',
            name: 'iaq',
            component: IaqView,
            meta: { nav: 'iaq' },
        },
        {
            path: '/financing',
            name: 'financing',
            component: FinancingView,
            meta: { nav: 'financing' },
        },
        { path: '/about', name: 'about', component: AboutView, meta: { nav: 'about' } },
        {
            path: '/privacy',
            name: 'privacy',
            component: LegalView,
            meta: { doc: 'privacy' },
        },
        { path: '/terms', name: 'terms', component: LegalView, meta: { doc: 'terms' } },
        {
            path: '/disclaimer',
            name: 'disclaimer',
            component: LegalView,
            meta: { doc: 'disclaimer' },
        },
        { path: '/:pathMatch(.*)*', name: 'not-found', component: InProgressView },
    ],
})
